$(function(){
  $('.cr-footer-acttl').on('click', function(){
    $(this).next('.cr-footer-accon').slideToggle();
    $(this).toggleClass('open');
  });
});


function initRecommendSwiper() {
  $('.cr-multi-column-wrapper.swiper').each(function () {
    if ($(this).hasClass('swiper-initialized')) return;

    new Swiper(this, {
      slidesPerView: 'auto',

      navigation: {
        nextEl: $(this).find('.swiper-button-next-multiColumn').get(0),
        prevEl: $(this).find('.swiper-button-prev-multiColumn').get(0),
      },

      pagination: {
        el: $(this).find('.swiper-pagination-multiColumn').get(0),
        type: 'progressbar',
      }
    });
  });
}

// スワイパーの初回読み込み -----------------
initRecommendSwiper();
// recommendations後読み込み対応
const observer = new MutationObserver(function () {
  initRecommendSwiper();
});
observer.observe(document.body, {
  childList: true,
  subtree: true
});



// アプリで出力されているテキストの置き換え -----------------
$(function () {
  function changeCustomTitles() {
    // BUY IT WITH
    $('.lb-addon-title').each(function () {
      const $title = $(this);

      if ($title.find('.cr-buy-it-with').length) return;

      $title.html(`
        <div class="prose cr-buy-it-with">
          <h2 class="h2">BUY IT WITH</h2>
          <p class="h6">一緒に購入する</p>
        </div>
      `);
    });

    // REVIEWS
    $('.poingpong-review__product__tit').each(function () {
      const $title = $(this);
      if ($title.find('.cr-reviews-title').length) return;
      $title.replaceWith(`
        <div class="prose cr-reviews-title">
          <h2 class="h2">REVIEWS</h2>
          <p class="h6">お客様の声</p>
        </div>
      `);
    });

    // 購入者テキスト
    $('.poingpong-review__author_name_caption').each(function () {
      const $caption = $(this);

      if ($caption.text().trim() !== '購入者：') {
        $caption.text('購入者：');
      }
    });
    
    // レビュー件数
    $('.poingpong-review__product_review_rating_count').each(function () {
      const $count = $(this);
      // すでに変更済みならスキップ
      if ($count.hasClass('cr-review-count-changed')) return;
      // "( 12 )" → "12"
      const count = $count.text().replace(/[^\d]/g, '');
      if (count) {
        $count
          .addClass('cr-review-count-changed')
          .text(`(${count}件のレビュー)`);
      }
    });
  }

  // 初回
  changeCustomTitles();
  // アプリの後描画・再描画に対応
  const observer = new MutationObserver(function () {
    changeCustomTitles();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});